module.exports = __webpack_public_path__ + "img/slot.12c77a13.png";